import { Lottie } from '@web_opxp/lottie';
import React, { FC } from 'react';
import { connect } from 'react-redux';
import BrainSvg from '../../components/BrainSvg/BrainSvg';
import { IState } from '../../store/state';
import { unityPreloaderLottie } from '../constants';
import { isLottiePreloaderVisible, isStaticPreloaderVisible } from '../selectors';

export interface IUnityPreloaderProps {
  showLottiePreloader: boolean;
  showStaticPreloader: boolean;
}

const LottieAnimation = Lottie.Component.default;

export const UnityPreloaderFC: FC<IUnityPreloaderProps> = ({ showLottiePreloader, showStaticPreloader }) => {
  const showPreloaderClass = showStaticPreloader || showLottiePreloader ? ' show' : '';
  const showStaticClass = showStaticPreloader ? ' show' : '';
  return (
    <div className={`unity-preloader-area${showPreloaderClass}`}>
      <div className={`static${showStaticClass}`}>
        <BrainSvg className="loading-brain" />
      </div>
      {showLottiePreloader ? <LottieAnimation name={unityPreloaderLottie} autoplay={true} loop={false} /> : null}
    </div>
  );
};

const mapStateToProps = (state: IState) => {
  const showLottiePreloader = isLottiePreloaderVisible(state);
  const showStaticPreloader = isStaticPreloaderVisible(state);
  return {
    showLottiePreloader,
    showStaticPreloader,
  };
};

const UnityPreloader = connect(mapStateToProps)(UnityPreloaderFC);

export default UnityPreloader;
